import { useTechnical } from '@/app/technical';
import type { WireComposed } from '@/api/wire';

/**
 * Where something an agent wrote was written (ADR-0032, ADR-0047, 0051):
 * the model, the region it ran in, and whose jurisdiction saw the prompt.
 * Said from the record, never assumed — a row with no route says that it
 * has none rather than borrowing the table's default.
 */
const JURISDICTION: Record<WireComposed['geography'], string> = {
  eu: 'EU',
  global: 'outside the EU',
  local: 'on the platform',
};

export function composedLine(c: WireComposed): string {
  return `${c.model} · ${c.region} (${JURISDICTION[c.geography]})`;
}

export function ComposedLine({ composed }: { composed: WireComposed | null }) {
  // The model and its region are the superadmin's; a person is told where
  // the words were written, which is what the law asks of us.
  const tech = useTechnical();
  if (!composed) return null;
  return (
    <span className="text-dense text-meta" data-testid="composed">
      {tech ? `Written on ${composedLine(composed)}` : `Written by an agent, ${JURISDICTION[composed.geography] === 'EU' ? 'in the EU' : JURISDICTION[composed.geography]}`}
    </span>
  );
}
